import { ELCLogger } from 'elc-logging';

const logger: ELCLogger = new ELCLogger('elc-component-renderer');

export const runPerformanceMarker = ({
    markArgument,
    measureArguments
}: {
    markArgument: string;
    measureArguments?: string[];
}) => {
    try {
        window.performance.mark(markArgument);

        if (measureArguments) {
            window.performance.measure.apply(null, measureArguments);
        }
    } catch (error) {
        logger.error({
            message: `[elc-component-renderer]: ${error}`,
            triggerType: 'error'
        });
    }
};
